import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getPbxController from './getPbxController.js'
import _module from 'module.js'
import _ from 'lodash'

let getPbxComponent = _.cloneDeep(getJrnDefaultComponent)
getPbxComponent.controller = getPbxController

_module.component('getPbx', getPbxComponent)
